<ng-container *ngIf="items$ | async as items">
  <ng-container *ngFor="let item of items; trackBy: trackById">
    <div class="media-container">
      <div class="media-selection">
        <div class="media">

          <!-- Media details template -->
          <div *ngIf="mediaDetails" class="details-container">
            <ng-container
              *ngTemplateOutlet="
                mediaDetails;
                context: { index: item.index, entity: item.entity, media: item.media }
              "
            ></ng-container>
          </div>

          <!-- Media card -->
          <div class="media-card-container">
            <media-card
              [media]="item.media"
              [forcedCoverHeight]="mediaCoverRatio"
              [rounded]="false"
              [selectable]="false"
              [elevated]="false"
              [class.cardOnly]="item.media.tags?.includes('hide.details')"
              (select)="onSelect(item.entity)"
            >
            </media-card>
          </div>

          <!-- Media badges template -->
          <ng-container
            *ngTemplateOutlet="
              mediaBadges;
              context: { index: item.index, entity: item.entity, media: item.media }
            "
          ></ng-container>

        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
